import React, { useEffect, useState } from 'react';
import {
	Box,
	Container,
	Grid,
	makeStyles,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Slider,
	withStyles,
	// FormControlLabel,
	Checkbox,
	Hidden,
	useMediaQuery,
	useTheme,
} from '@material-ui/core';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Skeleton from '@material-ui/lab/Skeleton';
import flightnew from '../../assets/images/flightnew.svg';
import trainnew from '../../assets/images/trainnew.svg';
import busnew from '../../assets/images/busnew.svg';
import hotelnew from '../../assets/images/busnew.svg';
import musafirbazarlogo from '../../assets/images/musafirbazarlogo.png';
import TitleText from '../../components/reusableComponents/TitleText';
import BodyText from '../../components/reusableComponents/BodyText';
import flightpro from '../../assets/images/flightpro.png';
import FlightDetailModal from '../../components/reusableComponents/FlightDetailModal';
import { setFlightId, toggleFlightModal } from '../../reducers/UiReducer';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import { useHistory, useLocation } from 'react-router-dom';
import { SearchFormDispatch } from '../../reducers/HomeReducer';
import Drawers from '../../components/Drawers';
import Login from '../../components/reusableComponents/Login';
// import OnewayForm from '../../form/OnewayForm';
import BusListForm from '../../form/BusListForm';
import { Divider } from '@mui/material';

const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiChip-sizeSmall': {
			height: 36,
		},
	},
	accodin: {
		'& .MuiAccordionSummary-content': {
			justifyContent: 'space-evenly',
		},
	},
	searhform: {
		// backgroundImage: `url(${Home})`,
		background: 'rgb(34, 118, 227)',
		height: 272,
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',

		paddingTop: 124,

		[theme.breakpoints.down('xs')]: {
			height: 590,
		},
	},
	radio: {
		'& .MuiTypography-body1': {
			fontSize: 13,
		},
	},
	scroll: {
		'&::-webkit-scrollbar': {
			width: '0.2em',
		},
		'&::-webkit-scrollbar-track': {
			// '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: 'rgba(0,0,0,.1)',
			outline: '1px solid slategrey',
			// borderTopLeftRadius: 5,
			// borderTopRightRadius: 5,
			borderRadius: 5,
		},
	},
}));

const GreenCheckbox = withStyles({
	root: {
		color: '#39c9bb',
		'&$checked': {
			color: '#39c9bb',
		},
	},
	checked: {},
})((props) => <Checkbox color='default' {...props} />);
const BusList = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const [expanded, setExpanded] = React.useState('');
	const [check, setCheck] = useState(false);
	const [check2, setCheck2] = useState(false);
	const [check3, setCheck3] = useState(false);
	const [check4, setCheck4] = useState(false);
	const [check5, setCheck5] = useState(false);
	const [scrollVal, SetScrollVal] = useState(10);
	const [scrollValResult, SetScrollValResult] = useState(10);
	const [hasMoreresult, SethasMoreResult] = useState(true);
	const [hasMorefilterData, SethasMoreFilterData] = useState(true);
	const [result, setResult] = useState([]);
	const history = useHistory();
	const theme = useTheme();
	const location = useLocation();
	const { search, loading } = useSelector((state) => state.home);
	const { filterDataR } = useSelector((state) => state.ui);
	const [stop1, setStop1] = useState(false);
	const [value, setValue] = React.useState([1000, 5000]);

	const [stop2, setStop2] = useState(false);
	const [stop3, setStop3] = useState(false);
	const [ac, setAC] = useState(false);
	const [nonac, setNAC] = useState(false);
	const [seater, setSeater] = useState(false);
	const [sleeper, setSleeper] = useState(false);
	const [morning, setMorning] = useState(false);
	const [dophar, setDOphar] = useState(false);
	const [toggle, setToggle] = useState(false);
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const matches2 = useMediaQuery(theme.breakpoints.down('xs'));
	const handleSlider = (event, newValue) => {
		setValue(newValue);
		console.log(newValue);
		let checkData = [];
		if (search && newValue) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					let a = item.Fare.BaseFare;
					let b = newValue[0];
					let c = newValue[1];
					if (a >= b && a <= c) {
						checkData.push({
							...item,
						});
					}
				});
		}

		setResult(checkData);
		SetScrollValResult(10);
		console.log('Slider Value', checkData);
	};
	const handleCheck = (event) => {
		setCheck(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		if (search && event.target.name) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
		}
		console.log(checkData);
		if (check) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(...result, checkData);
		}
	};
	const handleCheckGO = (event) => {
		setCheck2(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		if (search && event.target.name) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
		}
		console.log(checkData);
		if (check2) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(...result, checkData);
		}
	};
	const handleCheckIndigo = (event) => {
		setCheck3(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		if (search && event.target.name) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
		}
		console.log(checkData);
		if (check3) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(...result, checkData);
		}
	};
	const handleCheckAir = (event) => {
		setCheck4(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		if (search && event.target.name) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
		}
		console.log(checkData);
		if (check4) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(...result, checkData);
		}
	};
	const handleCheckVistara = (event) => {
		setCheck5(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		if (search && event.target.name) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
		}
		console.log(checkData);
		if (check5) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(...result, checkData);
		}
	};
	const handleChange = (panel) => (event, newExpanded) => {
		setExpanded(newExpanded ? panel : false);
	};

	function valuetext(value) {
		return `${value}°C`;
	}
	function display(a) {
		var hours = Math.trunc(a / 60);
		var minutes = a % 60;
		console.log(hours + ':' + minutes);
	}
	function timeConvert(n) {
		var num = n;
		var hours = num / 60;
		var rhours = Math.floor(hours);
		var minutes = (hours - rhours) * 60;
		var rminutes = Math.round(minutes);
		return rhours + ' hr and ' + rminutes + ' min.';
	}
	console.log(location.state);
	let filterData = [];
	filterData =
		search &&
		search.data &&
		search.data.Response &&
		search.data.Response.Results[0].length > 0 &&
		search.data.Response.Results[0].slice().sort((a, b) => {
			return a.Fare.BaseFare - b.Fare.BaseFare;
		});
	console.log('fILTER', filterData);

	const fetchMoreData = () => {
		if (scrollVal >= filterData.length) {
			SethasMoreFilterData(false);
		}

		setTimeout(() => {
			SetScrollVal(scrollVal + 5);
		}, 500);
	};
	const fetchMoreDataResult = () => {
		if (scrollValResult >= filterData.length) {
			SethasMoreResult(false);
		}
		setTimeout(() => {
			SetScrollValResult(scrollValResult + 5);
		}, 500);
	};

	useEffect(() => {
		if (location.state) {
			dispatch(SearchFormDispatch(location.state.body, history));
		}
	}, [dispatch]);

	const handleOne = () => {
		let checkData = [];
		if (search) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 1) {
						checkData.push({
							...item,
						});
					}
				});
		}
		console.log(checkData);
		if (stop1) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}
	};
	const handleTwo = () => {
		let checkData = [];
		if (search) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 2) {
						checkData.push({
							...item,
						});
					}
				});
		}
		console.log(checkData);
		setResult(checkData);
		if (stop2) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}
	};
	const handleThree = () => {
		let checkData = [];
		if (search) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 3) {
						checkData.push({
							...item,
						});
					}
				});
		}
		console.log(checkData);
		setResult(checkData);
		if (stop3) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}
	};
	const handlemorning = () => {
		let checkData = [];
		if (search) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					console.log(
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Origin.DepTime.substr(11, 2);
						})
					);
					console.log(
						'Dept',
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Destination.ArrTime.substr(11, 2);
						})
					);
					let a = item.Segments[0].slice(0, 1).map((i) => {
						return i.Origin.DepTime.substr(11, 2);
					});
					let b = item.Segments[0].slice(0, 1).map((i) => {
						return i.Destination.ArrTime.substr(11, 2);
					});
					if (a >= 5 && b <= 12) {
						checkData.push({
							...item,
						});
					}
				});
		}
		if (morning) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}
		console.log('Morning', checkData);
	};
	const handledophar = () => {
		let checkData = [];
		if (search) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					console.log(
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Origin.DepTime.substr(11, 2);
						})
					);
					console.log(
						'Dept',
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Destination.ArrTime.substr(11, 2);
						})
					);
					let a = item.Segments[0].slice(0, 1).map((i) => {
						return i.Origin.DepTime.substr(11, 2);
					});
					let b = item.Segments[0].slice(0, 1).map((i) => {
						return i.Destination.ArrTime.substr(11, 2);
					});
					if (a >= 12 && b <= 18) {
						checkData.push({
							...item,
						});
					}
				});
		}
		if (dophar) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}
		console.log('Dophar', checkData);
	};

	console.log(location.state);
	console.log(result);
	console.log(scrollVal);
	return (
		<>
			<header className='header'>
				<a href='#' className='logo'>
					<img
						src={musafirbazarlogo}
						width='200px'
						height='50px'
						onClick={() => history.push('/')}></img>
				</a>
				<Hidden only={['xs']}>
					<Box display='flex'>
						<Box
							display='flex'
							alignItems='center'
							onClick={() => history.push('/home')}>
							<img
								src={flightnew}
								style={{
									filter:
										' invert(46%) sepia(45%) saturate(4226%) hue-rotate(348deg) brightness(96%) contrast(91%)',
								}}></img>
							<TitleText four textStyle={{ color: '#EC5B25' }}>
								Flights
							</TitleText>
						</Box>
						<Box
							display='flex'
							alignItems='center'
							ml={'30px'}
							onClick={() => history.push('/new')}>
							<img src={trainnew}></img>
							<TitleText four>Trains</TitleText>
						</Box>
						<Box
							display='flex'
							alignItems='center'
							ml={'30px'}
							onClick={() => history.push('/buses')}>
							<img src={busnew}></img>
							<TitleText four>Buses</TitleText>
						</Box>
						<Box display='flex' alignItems='center' ml={'30px'}>
							<img src={hotelnew}></img>
							<TitleText four>Hotels</TitleText>
						</Box>
					</Box>
				</Hidden>

				<div className='icons'>
					<div className='fas fa-moon' id='theme-btn'></div>
					<div
						className='fas fa-user'
						id='login-btn'
						onClick={() => history.push('/agent')}></div>
					<div
						className='fas fa-bars'
						id='menu-btn'
						onClick={() => {
							let loginForm = document.querySelector('.login-form');
							let navbar = document.querySelector('.navbar');
							loginForm.classList.toggle('active');
							navbar.classList.remove('active');
						}}></div>
				</div>

				<nav className='navbar'>
					<a href='#home'>home</a>
					<a href='#packages'>packages</a>
					<a href='#services'>services</a>
					<a href='#pricing'>pricing</a>
					<a href='#review'>review</a>
					<a href='#contact'>contact</a>
					<a href='#blogs'>blogs</a>
				</nav>

				<form action='' className='login-form'>
					<div className='inputBox'>
						<span>username</span>
						<input type='text' placeholder='enter your name' />
					</div>

					<div className='inputBox'>
						<span>password</span>
						<input type='password' placeholder='enter your password' />
					</div>

					<div className='remember'>
						<input type='checkbox' name='' id='login-remember' />
						<label for='login-remember'>remember me</label>
					</div>

					<input type='submit' className='btn' value='login' />
				</form>
			</header>

			<Box
				className={classes.searhform}
				style={{ backgroundPosition: matches2 ? '' : '1px -443px' }}>
				<Container>
					<BusListForm />
				</Container>
			</Box>
			<Box mt={'35px'}>
				<Container>
					<Box
						style={{
							textAlign: 'justify',
							border: '1px solid #d7d7d7',
							padding: 10,
							background: 'white',
						}}>
						<BodyText
							textStyle={{
								color: 'red',
								fontFamily: 'Josefin Sans, sans-serif',
								fontWeight: 500,
								fontSize: 16,
							}}>
							Important Information
						</BodyText>
					</Box>
					<Box className={classes.accodin}>
						<Accordion
							square
							expanded={expanded === 'panel1'}
							onChange={handleChange('panel1')}>
							<AccordionSummary
								aria-controls='panel1d-content'
								id='panel1d-header'>
								{/* <Box alignItems='center'>
									<i class='fa-solid fa-filter'></i>
								</Box> */}
								<Hidden only={['xs']}>
									<Box display='flex' alignItems='center'>
										<TitleText
											textStyle={{
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
												fontSize: 14,
											}}>
											BUS TYPE
										</TitleText>
										<ExpandMoreIcon />
									</Box>
									<Box display='flex' alignItems='center'>
										<TitleText
											textStyle={{
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
												fontSize: 14,
											}}>
											POPULAR
										</TitleText>
										<ExpandMoreIcon />
									</Box>
									<Box display='flex' alignItems='center'>
										<TitleText
											textStyle={{
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
												fontSize: 14,
											}}>
											ARRIVAL TIME
										</TitleText>
										<ExpandMoreIcon />
									</Box>
									<Box display='flex' alignItems='center'>
										<TitleText
											textStyle={{
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
												fontSize: 14,
											}}>
											DEPARTURE TIME
										</TitleText>
										<ExpandMoreIcon />
									</Box>
								</Hidden>
								{/* <Box display='flex' alignItems='center'>
									<TitleText
										textStyle={{
											fontFamily: 'Josefin Sans, sans-serif',
											fontWeight: 500,
											fontSize: 14,
										}}>
										RESET ALL
									</TitleText>
								</Box> */}
							</AccordionSummary>
							<AccordionDetails>
								<Grid container spacing={2}>
									<Grid item xs={12} lg={3}>
										<Box
											display={'flex'}
											style={{ padding: 10, justifyContent: 'space-between' }}>
											<Box
												onClick={() => {
													handleOne();
													ac ? setAC(false) : setAC(true);
												}}
												style={{
													// width: '40px',
													padding: '6px 45px',
													background: ac ? 'rgb(34, 118, 227)' : '#eee',
													color: ac ? 'white' : '#666',
													border: '1px solid #ddd',
													borderRadius: '2px',
													fontWeight: 700,
													textAlign: 'center',
													cursor: 'pointer',
												}}>
												<BodyText textStyle={{ fontSize: 14 }}>AC</BodyText>
											</Box>
											<Box
												onClick={() => {
													handleTwo();
													nonac ? setNAC(false) : setNAC(true);
												}}
												style={{
													// width: '40px',
													padding: '6px 45px',
													background: nonac ? 'rgb(34, 118, 227)' : '#eee',
													color: nonac ? 'white' : '#666',
													border: '1px solid #ddd',
													borderRadius: '2px',
													fontWeight: 700,
													textAlign: 'center',
													marginLeft: 10,
													cursor: 'pointer',
												}}>
												<BodyText textStyle={{ fontSize: 14 }}>Non-AC</BodyText>
											</Box>
											{/* <Box
												onClick={() => {
													handleThree();
													stop3 ? setStop3(false) : setStop3(true);
												}}
												style={{
													width: '40px',
													padding: '6px 0px',
													background: stop3 ? 'rgb(57, 201, 187)' : '#eee',
													color: stop3 ? 'white' : '#666',
													border: '1px solid #ddd',
													borderRadius: '2px',
													fontWeight: 700,
													textAlign: 'center',
													marginLeft: 10,
													cursor: 'pointer',
												}}>
												<BodyText textStyle={{ fontSize: 14 }}>2</BodyText>
											</Box> */}
										</Box>
										<Box
											display={'flex'}
											style={{ padding: 10, justifyContent: 'space-between' }}>
											<Box
												onClick={() => {
													handleOne();
													seater ? setSeater(false) : setSeater(true);
												}}
												style={{
													// width: '40px',
													padding: '6px 45px',
													background: seater ? 'rgb(34, 118, 227)' : '#eee',
													color: seater ? 'white' : '#666',
													border: '1px solid #ddd',
													borderRadius: '2px',
													fontWeight: 700,
													textAlign: 'center',
													cursor: 'pointer',
												}}>
												<BodyText textStyle={{ fontSize: 14 }}>Seater</BodyText>
											</Box>
											<Box
												onClick={() => {
													handleTwo();
													sleeper ? setSleeper(false) : setSleeper(true);
												}}
												style={{
													// width: '40px',
													padding: '6px 45px',
													background: sleeper ? 'rgb(34, 118, 227)' : '#eee',
													color: sleeper ? 'white' : '#666',
													border: '1px solid #ddd',
													borderRadius: '2px',
													fontWeight: 700,
													textAlign: 'center',
													marginLeft: 10,
													cursor: 'pointer',
												}}>
												<BodyText textStyle={{ fontSize: 14 }}>
													Sleeper
												</BodyText>
											</Box>
										</Box>
									</Grid>
									<Grid item xs={12} lg={3}>
										<Box
											ml={'50px'}
											mt={matches ? '20px' : ''}
											className={classes.radio}>
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check}
														onChange={handleCheck}
														name='SpiceJet'
													/>
												}
												label='GODeal Discount'
											/>
											<br />
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check2}
														onChange={handleCheckGO}
														name='GO FIRST'
													/>
												}
												label='Free Cancellation'
											/>
											<br />
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check3}
														onChange={handleCheckIndigo}
														name='Indigo'
													/>
												}
												label='Top Rated Buses'
											/>
											<br />
										</Box>
									</Grid>
									<Grid item xs={12} lg={3}>
										<Grid container spacing={2}>
											<Grid item xs={6}>
												<Box
													style={{
														background: 'rgb(243, 246, 248)',
														textAlign: 'center',
														padding: 8,
													}}>
													<BodyText textStyle={{ fontSize: 13 }}>
														12 midnight-6 AM
													</BodyText>
												</Box>
												<Box
													mt={'10px'}
													style={{
														background: 'rgb(243, 246, 248)',
														textAlign: 'center',
														padding: 8,
													}}>
													<BodyText textStyle={{ fontSize: 13 }}>
														12 midnight-6 AM
													</BodyText>
												</Box>
											</Grid>
											<Grid item xs={6}>
												<Box
													style={{
														background: 'rgb(243, 246, 248)',
														padding: 8,
														textAlign: 'center',
													}}>
													<BodyText textStyle={{ fontSize: 13 }}>
														12 midnight-6 AM
													</BodyText>
												</Box>
												<Box
													mt={'10px'}
													style={{
														background: 'rgb(243, 246, 248)',
														textAlign: 'center',
														padding: 8,
													}}>
													<BodyText textStyle={{ fontSize: 13 }}>
														12 midnight-6 AM
													</BodyText>
												</Box>
											</Grid>
										</Grid>
									</Grid>
									<Grid item xs={12} lg={3}>
										<Grid container spacing={2}>
											<Grid item xs={6}>
												<Box
													style={{
														background: 'rgb(243, 246, 248)',
														textAlign: 'center',
														padding: 8,
													}}>
													<BodyText textStyle={{ fontSize: 13 }}>
														12 midnight-6 AM
													</BodyText>
												</Box>
												<Box
													mt={'10px'}
													style={{
														background: 'rgb(243, 246, 248)',
														textAlign: 'center',
														padding: 8,
													}}>
													<BodyText textStyle={{ fontSize: 13 }}>
														12 midnight-6 AM
													</BodyText>
												</Box>
											</Grid>
											<Grid item xs={6}>
												<Box
													style={{
														background: 'rgb(243, 246, 248)',
														padding: 8,
														textAlign: 'center',
													}}>
													<BodyText textStyle={{ fontSize: 13 }}>
														12 midnight-6 AM
													</BodyText>
												</Box>
												<Box
													mt={'10px'}
													style={{
														background: 'rgb(243, 246, 248)',
														textAlign: 'center',
														padding: 8,
													}}>
													<BodyText textStyle={{ fontSize: 13 }}>
														12 midnight-6 AM
													</BodyText>
												</Box>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</AccordionDetails>
						</Accordion>
					</Box>
					<Grid container style={{ marginTop: 20 }} spacing={2}>
						<Grid item xs={12}>
							<Grid container spacing={4}>
								<Hidden only={['xs', 'sm']}>
									<Grid item xs={3} lg={3}>
										<Box>
											<img src={flightpro} width='100%' height='216px'></img>
										</Box>
									</Grid>
								</Hidden>
								<Grid item xs={12} md={9} lg={9}>
									<Box
										display='flex'
										justifyContent='space-between'
										style={{
											background: '#eee',
											padding: '10px',
											borderBottom: '1px solid #ddd',
											margin: '0 0 15px',
										}}>
										<Box>
											<TitleText two textStyle={{ color: '#666' }}>
												SORT BY
											</TitleText>
										</Box>
										<Box>
											<TitleText two textStyle={{ color: '#666' }}>
												DEPART
											</TitleText>
										</Box>
										<Box>
											<TitleText two textStyle={{ color: '#666' }}>
												DURATION
											</TitleText>
										</Box>

										<Box>
											<TitleText two textStyle={{ color: '#666' }}>
												ARRIVAL
											</TitleText>
										</Box>
										<Box>
											<TitleText two textStyle={{ color: '#666' }}>
												PRICE(Per Adult)
											</TitleText>
										</Box>
									</Box>
									{[0, 1, 2, 3].map((i, index) => {
										return (
											<>
												<Box
													style={{
														boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
														// padding: 8,
														background: 'white',
														paddingTop: '2px',
														paddingLeft: '20px',
														paddingRight: '20px',
														paddingBottom: '13px',
														marginTop: index == 0 ? '' : 10,
													}}>
													<Box
														display='flex'
														// style={{
														// 	boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
														// 	padding: 8,
														// }}
														justifyContent='space-between'
														alignItems='center'
														mt={'20px'}>
														<Box alignItems='center'>
															<TitleText four>
																Shyamoli Paribahan Pvt Ltd
															</TitleText>
															<BodyText
																textStyle={{
																	fontSize: 13,
																}}>
																Multi-Axle A/C Semi Sleeper (2+2)
															</BodyText>
															<p>
																<span
																	style={{
																		background: 'rgb(24, 161, 96)',
																		borderColor: 'rgb(24, 161, 96)',
																		color: 'white',
																		border: '1px solid',
																		paddingRight: '0.6rem',
																		paddingLeft: '0.6rem',
																		color: 'rgb(255, 255, 255)',
																		borderRadius: '0.3rem',
																		fontSize: '1.1rem',
																	}}>
																	4.5/5
																</span>
															</p>
														</Box>

														<Box>
															<TitleText four>15:30</TitleText>
															<BodyText
																textStyle={{
																	fontSize: 13,
																}}>
																Esplanade
															</BodyText>
														</Box>
														<Box>
															<TitleText four>10:00</TitleText>
															<BodyText
																textStyle={{
																	fontSize: 13,
																}}>
																Dhanbad
															</BodyText>
														</Box>
														<Box alignItems='center' display='flex'>
															<TitleText
																textStyle={{
																	fontSize: 22,
																}}>
																Rs 500
															</TitleText>
														</Box>
														<Box>
															<BodyText textStyle={{ fontSize: 12 }}>
																Total 21 seats left
															</BodyText>
															<Box
																onClick={() =>
																	toggle ? setToggle(false) : setToggle(true)
																}
																style={{
																	color: 'white',
																	background: '#39c9bb',
																	padding: '8px 25px',
																	borderRadius: 8,
																	boxShadow:
																		'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																}}>
																<TitleText>Select Seat</TitleText>
															</Box>
														</Box>
													</Box>
													<Grid container spacing={1}>
														<Grid item xs={6}>
															<Box
																mt={'10px'}
																display='flex'
																style={{
																	display: toggle ? '' : 'none',
																}}>
																<Box
																	style={{
																		background: 'rgb(34, 118, 227)',
																		width: '25px',
																		color: 'white',
																		borderRadius: '41px',
																		height: '25px',
																		textAlign: 'center',
																	}}>
																	<TitleText four>1</TitleText>
																</Box>
																<TitleText
																	four
																	textStyle={{
																		marginLeft: 5,
																	}}>
																	Select your Seat
																</TitleText>
															</Box>
															<Box
																mt={'10px'}
																display='flex'
																style={{
																	display: toggle ? '' : 'none',
																}}>
																<Box display='flex'>
																	<Box
																		style={{
																			background: 'darkred',
																			width: 15,
																			height: 15,
																			borderRadius: 5,
																			border: '1px solid rgb(151, 151, 151)',
																		}}></Box>
																	<BodyText
																		textStyle={{
																			marginLeft: 10,
																			fontWeight: 700,
																		}}>
																		Booked
																	</BodyText>
																</Box>
																<Box display='flex' ml={'10px'}>
																	<Box
																		style={{
																			background: 'white',
																			width: 15,
																			height: 15,
																			borderRadius: 5,
																			border: '1px solid rgb(151, 151, 151)',
																		}}></Box>
																	<BodyText
																		textStyle={{
																			marginLeft: 10,
																			fontWeight: 700,
																		}}>
																		Available
																	</BodyText>
																</Box>
																<Box display='flex' ml={'10px'}>
																	<Box
																		style={{
																			background: 'rgb(250, 57, 136)',
																			width: 15,
																			height: 15,
																			borderRadius: 5,
																			border: '1px solid rgb(151, 151, 151)',
																		}}></Box>
																	<BodyText
																		textStyle={{
																			marginLeft: 10,
																			fontWeight: 700,
																		}}>
																		Ladies
																	</BodyText>
																</Box>
																<Box display='flex' ml={'10px'}>
																	<Box
																		style={{
																			background: 'rgb(34, 118, 227)',
																			width: 15,
																			height: 15,
																			borderRadius: 5,
																			border: '1px solid rgb(151, 151, 151)',
																		}}></Box>
																	<BodyText
																		textStyle={{
																			marginLeft: 10,
																			fontWeight: 700,
																		}}>
																		Men
																	</BodyText>
																</Box>
															</Box>
															<Box
																mt={'10px'}
																display='flex'
																justifyContent='space-between'
																style={{
																	// width: '26%',
																	display: toggle ? '' : 'none',
																	transition: 'all .2s linear',
																	border: '1px solid rgb(225, 225, 225)',
																	// width: '450px',
																	// height: '300px',
																	padding: 8,
																}}>
																<Box>{/* <Divider /> */}</Box>
																<Box>
																	<Box display='flex' mt={'10px'}>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>4</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'white',
																				color: 'black',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>8</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>12</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>16</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>20</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>24</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>28</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>32</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>36</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>40</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>44</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>48</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>53</BodyText>
																		</Box>
																	</Box>
																	<Box display='flex' mt={'10px'}>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>3</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				border: '1px solid rgb(225, 225, 225)',
																				marginLeft: 8,
																			}}>
																			<BodyText>7</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>11</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>15</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'white',
																				color: 'black',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>19</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>23</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'rgb(34, 118, 227)',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>27</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>31</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>35</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>39</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>43</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>47</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'rgb(34, 118, 227)',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>52</BodyText>
																		</Box>
																	</Box>
																	<Box display='flex' mt={'10px'}>
																		<Box
																			style={{
																				background: 'white',
																				color: 'white',
																				padding: '6px',
																				border: '1px solid white',
																			}}>
																			<BodyText>3</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'white',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid white',
																			}}>
																			<BodyText>7</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'white',
																				color: 'white',
																				padding: '6px',
																				border: '1px solid white',
																				marginLeft: 8,
																			}}>
																			<BodyText>11</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'white',
																				color: 'white',
																				border: '1px solid white',
																				padding: '6px',
																				marginLeft: 8,
																			}}>
																			<BodyText>15</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'white',
																				color: 'white',
																				padding: '6px',
																				border: '1px solid white',
																				marginLeft: 8,
																			}}>
																			<BodyText>19</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'white',
																				color: 'white',
																				padding: '6px',
																				border: '1px solid white',
																				marginLeft: 8,
																			}}>
																			<BodyText>23</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'white',
																				color: 'white',
																				padding: '6px',
																				border: '1px solid white',
																				marginLeft: 8,
																			}}>
																			<BodyText>27</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'white',
																				color: 'white',
																				padding: '6px',
																				border: '1px solid white',
																				marginLeft: 8,
																			}}>
																			<BodyText>31</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'white',
																				color: 'white',
																				border: '1px solid white',
																				padding: '6px',
																				marginLeft: 8,
																			}}>
																			<BodyText>35</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'white',
																				color: 'white',
																				padding: '6px',
																				border: '1px solid white',
																				marginLeft: 8,
																			}}>
																			<BodyText>39</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'white',
																				color: 'white',
																				padding: '6px',
																				border: '1px solid white',
																				marginLeft: 8,
																			}}>
																			<BodyText>43</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'white',
																				color: 'white',
																				border: '1px solid white',
																				padding: '6px',
																				marginLeft: 8,
																			}}>
																			<BodyText>47</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>51</BodyText>
																		</Box>
																	</Box>
																	<Box display='flex' mt={'10px'}>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>2</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>6</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>10</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>14</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'rgb(250, 57, 136)',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>18</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>22</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'rgb(250, 57, 136)',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>26</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>30</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>34</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>38</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>42</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>46</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>50</BodyText>
																		</Box>
																	</Box>
																	<Box display='flex' mt={'10px'}>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>1</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>5</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 14,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>9</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>13</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				border: '1px solid rgb(225, 225, 225)',
																				marginLeft: 8,
																			}}>
																			<BodyText>17</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>21</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>25</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>29</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>33</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>37</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>41</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>45</BodyText>
																		</Box>
																		<Box
																			style={{
																				background: 'darkred',
																				color: 'white',
																				padding: '6px',
																				marginLeft: 8,
																				border: '1px solid rgb(225, 225, 225)',
																			}}>
																			<BodyText>49</BodyText>
																		</Box>
																	</Box>
																</Box>
															</Box>
															<Box
																mt={'10px'}
																style={{
																	background: 'rgb(255, 109, 56)',
																	textAlign: 'center',
																	color: 'white',
																	padding: 8,
																	borderRadius: 10,
																	display: toggle ? '' : 'none',
																}}>
																<TitleText four>CONTINUE</TitleText>
															</Box>
															<Box
																style={{ display: toggle ? '' : 'none' }}
																mt={'10px'}
																display='flex'
																justifyContent='space-between'>
																<Box>
																	<BodyText textStyle={{ fontSize: 12 }}>
																		Seat Selected
																	</BodyText>
																	<TitleText>20</TitleText>
																</Box>
																<Box>
																	<TitleText textStyle={{ fontSize: 20 }}>
																		Rs 650
																	</TitleText>
																</Box>
															</Box>
														</Grid>
														<Grid item xs={6}>
															<Box
																mt={'10px'}
																display='flex'
																style={{
																	display: toggle ? '' : 'none',
																}}>
																<Box
																	style={{
																		background: 'rgb(34, 118, 227)',
																		width: '25px',
																		color: 'white',
																		borderRadius: '41px',
																		height: '25px',
																		textAlign: 'center',
																	}}>
																	<TitleText four>2</TitleText>
																</Box>
																<TitleText
																	four
																	textStyle={{
																		// fontSize: 14,
																		marginLeft: 5,
																	}}>
																	Select boarding and dropping point
																</TitleText>
															</Box>
															<Box
																mt={'10px'}
																style={{ display: toggle ? '' : 'none' }}
																display='flex'
																justifyContent='space-between'>
																<Box>
																	<BodyText textStyle={{ fontSize: 14 }}>
																		Boarding Point
																	</BodyText>
																	<Box
																		className={classes.scroll}
																		mt={'4px'}
																		style={{
																			border: '1px solid rgb(225, 225, 225)',
																			borderRadius: '3px',
																			width: '21rem',
																			display: 'flex',
																			background: 'white',
																			flexDirection: 'column',
																			height: '270px',
																			overflowY: 'scroll',
																			padding: 5,
																		}}>
																		<FormControl>
																			<RadioGroup
																				aria-labelledby='demo-controlled-radio-buttons-group'
																				name='controlled-radio-buttons-group'
																				value={value}
																				onChange={handleChange}>
																				<FormControlLabel
																					value='female'
																					control={<Radio />}
																					label='Esplande Bus Stand Shyamoli Paribahan Counter, Opposite of B.C.Roy Market. Customer Care- / 62, Bus & Driver number will be sent before 30 minutes of departure via SMS'
																				/>
																				<FormControlLabel
																					style={{ marginTop: 20 }}
																					value='male'
																					control={<Radio />}
																					label='Esplande Bus Stand Shyamoli Paribahan Counter, Opposite of B.C.Roy Market. Customer Care- / 62, Bus & Driver number will be sent before 30 minutes of departure via SMS'
																				/>
																				<FormControlLabel
																					style={{ marginTop: 20 }}
																					value='male'
																					control={<Radio />}
																					label='Esplande Bus Stand Shyamoli Paribahan Counter, Opposite of B.C.Roy Market. Customer Care- / 62, Bus & Driver number will be sent before 30 minutes of departure via SMS'
																				/>
																			</RadioGroup>
																		</FormControl>
																	</Box>
																</Box>
																<Box ml={'10px'}>
																	<BodyText textStyle={{ fontSize: 14 }}>
																		Dropping Point
																	</BodyText>
																	<Box
																		className={classes.scroll}
																		mt={'4px'}
																		style={{
																			border: '1px solid rgb(225, 225, 225)',
																			borderRadius: '3px',
																			width: '21rem',
																			display: 'flex',
																			background: 'white',
																			flexDirection: 'column',
																			height: '270px',
																			overflowY: 'scroll',
																			WebkitScrollbarWidth: '1em',
																			padding: 5,
																		}}>
																		<FormControl>
																			<RadioGroup
																				aria-labelledby='demo-controlled-radio-buttons-group'
																				name='controlled-radio-buttons-group'
																				value={value}
																				onChange={handleChange}>
																				<FormControlLabel
																					value='female'
																					control={<Radio />}
																					label='Esplande Bus Stand Shyamoli Paribahan Counter, Opposite of B.C.Roy Market. Customer Care- / 62, Bus & Driver number will be sent before 30 minutes of departure via SMS'
																				/>
																				<FormControlLabel
																					style={{ marginTop: 20 }}
																					value='male'
																					control={<Radio />}
																					label='Esplande Bus Stand Shyamoli Paribahan Counter, Opposite of B.C.Roy Market. Customer Care- / 62, Bus & Driver number will be sent before 30 minutes of departure via SMS'
																				/>
																				<FormControlLabel
																					style={{ marginTop: 20 }}
																					value='male'
																					control={<Radio />}
																					label='Esplande Bus Stand Shyamoli Paribahan Counter, Opposite of B.C.Roy Market. Customer Care- / 62, Bus & Driver number will be sent before 30 minutes of departure via SMS'
																				/>
																			</RadioGroup>
																		</FormControl>
																	</Box>
																</Box>
															</Box>
														</Grid>
													</Grid>

													<Box></Box>
												</Box>
											</>
										);
									})}
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Container>
			</Box>
			<FlightDetailModal />
			<Drawers />
			<Login />
		</>
	);
};

export default BusList;
